<template>
  <div class="row">
    <div class="col-20 p-5 text-center position-relative">
      <img
        :src="$publicPath + 'img/video-placeholder.png'"
        class="img-fluid"
      >
      <span class="video-info position-absolute"><img :src="$publicPath + 'img/soon.svg'"></span>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {

    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
    .video-info {
        top: 50%;
        left: 50%;
        transform: translateY(-50%) translateX(-50%);
        img {
          max-width: 4rem;
        }
    }
</style>
